import {ITEM_TYPES} from '@explorer/constants/item-types';

export const ORDERS_SHORT_POLLING_INTERVAL = 0.5 * 60 * 1000; //  1 minute
export const ORDERS_LONG_POLLING_INTERVAL = 5 * 60 * 1000; //  5 minutes
export const ORDERS_EXTRA_LONG_POLLING_INTERVAL = 30 * 60 * 1000; //  30 minutes
export const ORDER_STATES = {
  SUCCESS: 'success',
  RUNNING: 'running',
  FAILED: 'failed',
  PARTIAL: 'partial',
  CANCELLED: 'cancelled',
  QUEUED: 'queued',
};

export const MAX_ITEMS_PER_ORDER = {
  [ITEM_TYPES.SKYSATSCENE]: 100,
  [ITEM_TYPES.SKYSATCOLLECT]: 50,
  [ITEM_TYPES.PELICANSCENE]: 50,
  [ITEM_TYPES.TANAGERSCENE]: 50,
  default: 100,
};

// This dictates the priority for default bundle selected in the orders dialog
export const DOWNLOAD_DEFAULT_SELECTIONS = {
  [ITEM_TYPES.RESCENE]: ['basic_analytic'],
  [ITEM_TYPES.REORTHOTILE]: ['analytic_sr'],
  [ITEM_TYPES.SKYSATCOLLECT]: ['pansharpened_udm2', 'pansharpened'],
  [ITEM_TYPES.SKYSATSCENE]: [
    'pansharpened_udm2',
    'pansharpened',
    'basic_l1a_dn',
  ],
  [ITEM_TYPES.PSSCENE]: ['analytic_sr_udm2', 'analytic_udm2', 'visual'],
  [ITEM_TYPES.PELICANSCENE]: ['pansharpened_udm2', 'basic_l1a_dn'],
  DEFAULT: ['analytic_udm2', 'analytic', 'visual'],
};

export const HOSTED_DATA_DEFAULT_SELECTIONS = {
  [ITEM_TYPES.REORTHOTILE]: ['analytic_sr'],
  [ITEM_TYPES.SKYSATCOLLECT]: ['pansharpened_udm2', 'pansharpened'],
  [ITEM_TYPES.SKYSATSCENE]: ['pansharpened_udm2', 'pansharpened'],
  [ITEM_TYPES.PSSCENE]: ['analytic_sr_udm2'],
  DEFAULT: ['analytic_sr'],
};

export const FILE_FORMATS = {
  PL_NITF: 'PL_NITF',
  COG: 'COG',
};

export const FILE_FORMATS_LABELS = {
  PL_NITF: 'NITF 2.1',
  COG: 'Cloud Optimized GeoTIFF (COG)',
};

export const FILE_FORMATS_SHORT_LABELS = {
  PL_NITF: 'NITF 2.1',
  COG: 'COG',
};

// @see https://docs.planet.com/develop/apis/orders/delivery/#delivery-to-cloud-storage
export const CLOUD_STORAGE_PROVIDERS = [
  'amazon_s3',
  'azure_blob_storage',
  'google_cloud_storage',
];

export const DELIVERY_DESTINATIONS = {
  HOSTED_DATA: 'hostedData',
  DOWNLOAD: 'download',
  SENTINEL_HUB: 'sentinelHub',
};

export const STREAMABLE_ITEM_TYPES = [
  ITEM_TYPES.REORTHOTILE,
  ITEM_TYPES.SKYSATSCENE,
  ITEM_TYPES.SKYSATCOLLECT,
  ITEM_TYPES.PSSCENE,
];

export const NON_STREAMABLE_ITEM_TYPES = [
  ITEM_TYPES.RESCENE,
  ITEM_TYPES.PELICANSCENE,
];

export const SENTINEL_HUB_ITEM_TYPES = [
  ITEM_TYPES.PSSCENE,
  ITEM_TYPES.SKYSATSCENE,
  ITEM_TYPES.SKYSATCOLLECT,
  ITEM_TYPES.PELICANSCENE,
];

export const SENTINEL_HUB_DEFAULT_SELECTIONS = {
  [ITEM_TYPES.SKYSATCOLLECT]: [
    'panchromatic',
    'analytic_udm2',
    'analytic_sr_udm2',
    'analytic_sr',
    'analytic',
  ],
  [ITEM_TYPES.SKYSATSCENE]: [
    'panchromatic',
    'analytic_udm2',
    'analytic_sr_udm2',
    'analytic_sr',
    'analytic',
  ],
  [ITEM_TYPES.PSSCENE]: [
    'analytic_sr_udm2',
    'analytic_8b_sr_udm2',
    'analytic_sr',
    'analytic_udm2',
    'analytic_8b_udm2',
    'analytic',
  ],
  DEFAULT: ['analytic_sr_udm2'],
};

export const DEFAULT_SELECTIONS = {
  [DELIVERY_DESTINATIONS.DOWNLOAD]: DOWNLOAD_DEFAULT_SELECTIONS,
  [DELIVERY_DESTINATIONS.HOSTED_DATA]: HOSTED_DATA_DEFAULT_SELECTIONS,
  [DELIVERY_DESTINATIONS.SENTINEL_HUB]: SENTINEL_HUB_DEFAULT_SELECTIONS,
};

export const HIGH_LIMIT_ORGS = [1, 234995];
